import { useAuth } from '../hooks/useAuth';

export const checkIfExcludedFrom = product => {
    const { authStore } = useAuth();
    return (
        authStore.loggedIn &&
        authStore.user &&
        !authStore.user['com.sbgcore.can_link_to'].includes(product)
    );
};

export const isPick7iOSWebView = () => {
    return navigator.userAgent.includes('Pick7 iOS WebView');
};
